import React from "react";
import { useLocation } from "react-router-dom";
import PageHeader, { pageDescriptionSx } from "./PageHeader";
import LayerdIcon from "./LayerdIcon";
import { getPageIconForPath } from "../../icons/v2PageIcons";

export { pageDescriptionSx };

/**
 * v2 page heading with Lucide icon resolved from the current route (or override).
 */
export default function V2PageHeader({
  icon,
  title,
  description,
  helpTooltip,
  actions,
  sx,
  titleSx,
  descriptionSx,
  iconSize = "lg",
  iconColor = "primary",
}) {
  const { pathname } = useLocation();
  const LucideIcon = icon ?? getPageIconForPath(pathname);

  return (
    <PageHeader
      icon={<LayerdIcon icon={LucideIcon} size={iconSize} color={iconColor} />}
      title={title}
      description={description}
      helpTooltip={helpTooltip}
      actions={actions}
      sx={sx}
      titleSx={titleSx}
      descriptionSx={descriptionSx}
    />
  );
}
